var BootstrapMenu = require('bootstrap-menu');

export default {
    args: 'target',
    selector: null,
    menu: null,

    props: {
        target: String,
        selector: String,
    },

    data: {
    },

    connect() {
        this.menu = new BootstrapMenu(`#${this.el.getAttribute('id')} ${this.selector}`, {
            fetchElementData: function($rowElem) {
                var rowId = $rowElem.data('id');
                return { id: rowId, $el: $rowElem, number: $rowElem.data('number') };
            },
            actions: [{
                name: 'Zum Eigen-Devis hinzufügen',
                classNames: 'dropdown-item',
                iconClass: 'bi-box-arrow-right',
                onClick: this.addPositionToDevis,
            // }, {
            //     name: 'Neue Position hinzufügen',
            //     classNames: 'dropdown-item',
            //     iconClass: 'bi-plus',
            //     onClick: this.addPosition,
            }, {
                name: 'Position ändern',
                classNames: 'dropdown-item',
                iconClass: 'bi-pencil-square',
                onClick: this.changePosition,
            }, {
                name: 'Position löschen',
                classNames: 'dropdown-item text-danger',
                iconClass: 'bi-trash',
                onClick: this.deletePosition,
            }],
        });
    },

    events: [{
        name: 'click',
        el(component) { return component.el.querySelectorAll('.btn-context-click'); },
        handler(ev) {
            ev.preventDefault();
            ev.stopPropagation();
            var rowEl = $(ev.target).closest(this.selector);
            this.menu.open(rowEl, ev);
        }
    }],

    methods: {
        addPositionToDevis(row) {
            if (row.id) {
                devis.addPositionToDevis(row.id);
            }
        },
        addPosition(row) {
            if (row.id) {
                devis.addNewPosition(row.$el);
            }
        },
        deletePosition(row) {
            if (row.id) {
                messaging.askYesNo('Position löschen', 'Willst du diese Position wirklich löschen?', function () {
                    var url = '/Devis/Default/DeletePosition/' + row.id;
                    connection.getJson(url, {
                        onSuccess: function () {
                            row.$el.remove();
                            messaging.showGlobalMessage('success', null, 'Die Position wurde gelöscht.');
                        },
                    });
                });
            } else {
                debugger;
                row.$el.remove();
            }
        },
        changePosition(row) {
            if (row.id) {
                slidein.openUrl('/Devis/Default/CreateCatalogPositionSlideIn/' + row.id);
            }
        },
    },

}
